// import IconInputField from '../IconInputField'
import Btn from '../Btn'
import AddCircleIcon from '@mui/icons-material/AddCircle'
// import SearchIcon from '@mui/icons-material/Search'
// import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

import {
  TableContainer, Table, TableBody, TableRow, TableCell,
  Typography, Box, TableHead, useMediaQuery, Pagination
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import React, { useEffect, useState } from 'react'
import Loader from '../Loader/Loader'
import { useGetSupportTicketMutation } from '../../redux/api/supportApi'
import { convertDateToFormattedString } from '../../utils/dateTransfer'
import { useNavigate } from 'react-router-dom'
import { PATH } from '../../routes/constant'
import { type IDataSupportTicket } from '../../redux/api/types'
import { useDispatch, useSelector } from 'react-redux'
import { setLastTicketId } from '../../redux/features/createSupportTicketSlice'

const RoundedTableRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    backgroundColor: '#FFF',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA'
  },
  '& td:first-child': {
    backgroundColor: '#FFF',
    borderLeft: '0px solid #F7F8FA',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA',
    borderRadius: '15px 0 0 15px'
  },
  '& td:last-child': {
    backgroundColor: '#FFF',
    borderRight: '0px solid #F7F8FA',
    borderTop: '5px solid #F7F8FA',
    borderBottom: '5px solid #F7F8FA',
    borderRadius: '0 15px 15px 0'
  }
}))

const ThinTableCell = styled(TableCell)(({ theme }) => ({
  paddingTop: 15,
  paddingBottom: 15,
  paddingLeft: 0,
  paddingRight: 0
}))

const MyRequests: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const [page, setPage] = useState(1)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const supportTicket = useSelector((state: any) => state.supportTicketsState)

  const [getTicket, { data, isLoading }] = useGetSupportTicketMutation()

  useEffect(() => {
    getTicket({ page }).then().catch(e => {})
  }, [page])

  useEffect(() => {
    dispatch(setLastTicketId(supportTicket.tickets?.data[0]?.id))
  }, [supportTicket.tickets?.data])

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage)
  }

  if (data && data?.data?.length <= 0) {
    return <Box sx={{ textAlign: 'center', marginTop: '130px' }}>
      <Typography sx={{ color: '#7D8FB3', fontSize: '16px', lineHeight: '30px' }}>Looks like you haven’t submitted any support requests yet!</Typography>
      <Btn
          onClick={() => { navigate(PATH.SUPPORT_CREATE) }}
          variant='outlined'
          color='secondary'
          text='Submit a Ticket'
          sx={{ py: 1, marginTop: '24px' }}
      />
    </Box>
  }

  return (
    <>
      {isLoading
        ? <Box sx={{ marginTop: 20 }}><Loader /></Box>
        : <Box>
      <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', mb: 2 }}>
        <Typography sx={{ flexGrow: 1, fontSize: 16, fontWeight: 900, lineHeight: '20px', color: '#7D8FB3' }}>My Requests</Typography>
          <Btn
            onClick={() => { navigate(PATH.SUPPORT_CREATE) }}
            variant='outlined'
            color='secondary'
            text='Submit a Ticket'
            sx={{ py: 1 }}
            startIcon={
              <AddCircleIcon/>
            }
          />
      </Box>
      {/* <IconInputField
        id='search'
        fullWidth
        leftIcon={SearchIcon}
        leftIconColor='#C3CAD9'
        rightIcon={KeyboardArrowRightIcon}
        rightIconColor='#C3CAD9'
        placeholder='Search Requests'
      /> */}
      <TableContainer sx={{ borderCollapse: 'separate', pt: isMobile ? 3 : 4 }}>
        <Table sx={{ width: '100%', borderCollapse: 'separate' }}>
          { isMobile
            ? null
            : (
                <TableHead sx={{ '& td, & th': { border: 0 } }}>
                  <TableRow>
                    <TableCell sx={{ pl: 3, minWidth: '100px', color: '#7D8FB3' }}>Subject</TableCell>
                    <TableCell sx={{ color: '#7D8FB3', p: 0 }}>ID</TableCell>
                    <TableCell sx={{ color: '#7D8FB3', p: 0 }}>Created</TableCell>
                    <TableCell sx={{ color: '#7D8FB3', p: 0 }}>Updated</TableCell>
                    <TableCell sx={{ color: '#7D8FB3', p: 0 }}>Status</TableCell>
                  </TableRow>
                </TableHead>
              )
          }
          <TableBody>
          {data?.data?.map((row: IDataSupportTicket) => (
            <RoundedTableRow
              style={{ cursor: 'pointer' }}
              onClick={() => { navigate(PATH.SUPPORT_DETAILS(row.id)) }}
              key={row.id}
            >
              { isMobile
                ? (
                  <ThinTableCell sx={{ pl: 2, minWidth: '100px', color: '#7D8FB3' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
                      <Typography variant='body2' sx={{ fontWeight: 400 }}>{row.number}</Typography>
                      <Typography variant='body2' sx={{ ml: 1, fontWeight: 400 }}>{convertDateToFormattedString(row.createdDate)}</Typography>
                    </Box>
                    <Typography variant='h6' sx={{ fontWeight: 900 }}>{row.subject}</Typography>
                    <Typography variant='body2' sx={{ fontWeight: 400 }}>Updated: {convertDateToFormattedString(row.updatedDate)}</Typography>
                  </ThinTableCell>
                  )
                : (
                  <>
                    <ThinTableCell sx={{ pl: 3, minWidth: '100px', color: '#7D8FB3' }}>{row.subject}</ThinTableCell>
                    <ThinTableCell sx={{ color: '#7D8FB3' }}>{row.number}</ThinTableCell>
                    <ThinTableCell sx={{ color: '#7D8FB3' }}>{convertDateToFormattedString(row.createdDate)}</ThinTableCell>
                    <ThinTableCell sx={{ color: '#7D8FB3' }}>{convertDateToFormattedString(row.updatedDate)}</ThinTableCell>
                  </>
                  )
              }
              <ThinTableCell
                sx={{ pr: isMobile ? 2 : 3, color: '#7D8FB3' }}
                style={{ verticalAlign: isMobile ? 'top' : 'center' }}
              >
              { row.status === 'Open'
                ? <Typography variant='body2' color='#13BF24'>{row.status}</Typography>
                : <Typography variant='body2'>{row.status}</Typography>
              }
              </ThinTableCell>
            </RoundedTableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination count={data?.meta?.lastPage}
                   page={page}
                   onChange={handleChangePage} />
    </Box>}
    </>
  )
}

export default MyRequests
